// Eigene Datei für die `msalInstance`, damit der Entry-Bundle (index.jsx)
// keine Exports trägt. Vite würde sonst bei `import { msalInstance } from
// "../index"` und gleichzeitigem Entry `<script src="/src/index.jsx">` zwei
// verschiedene Module-URLs erzeugen, was zu doppelter Modul-Auswertung,
// doppeltem `createRoot` und MSAL `no_token_request_cache_error` führt.
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./authConfig";

export const msalInstance = new PublicClientApplication(msalConfig);
